import React from 'react';
import { Typography, CardMedia, Grid } from '@material-ui/core';

const data = (
<Typography component="div">
  <h1>C90(ANSI C) Compiler</h1>


  <h2>Objective</h2>
  <p>
    The objective for this project is to put language processing in to practise. The requirement for this coursework is to able to translate ANSI C code to python and compile to MIPS assembly.
  </p>

  <h2>Architecture Overview</h2>
  <img src={require('./archOverview.png')} width="300" /><br/>
  <p>
    The Object-oriented approach had being chosen for this project. AST uses abstract class to act as interface and uses inheritance to build an tree. We also used a register simulator that will simulate the register and memory movement of the MIPS CPU, making dynamic prediction on the stack space to be allocated to this function call. This class will then provide high level function call to allocate register for each variable in the C code.
    <br/>
    For details about the design and evaluation, please view the readme file from the Github link below.
  </p>


  <h2>Outcome</h2>
  <p>
   For this project, we passed 91/117 (77.8%) test with cohort average of 66/117 (56.4%) and highest 105/117 (89.7%). <br/>
   In addition, we also added support for multidimensional pointers which are not included in test, but I had implemented due to my enthusiasm. However, I under estimated the time taken to debug this, and was not able to test simple function thoroughly. This made me reflect on time estimation on large scale project.
  </p>

</Typography>
)
export default data